module.exports = __webpack_public_path__ + "static/florin-9b311752197ba404c76ec6fae953bfc9.png";